import { useState, useEffect, useRef, useContext } from "react";
// import bell_icon from "../assets/icons/bell-icon.svg";
// import red_exclamation from "../assets/icons/red_exclamation.svg";
import { CiMenuBurger } from "react-icons/ci";
import card_generation_icon from "../assets/icons/card_generation.svg";
import mycards_icon from "../assets/icons/mycards.svg";
import address_icon from "../assets/icons/address_book.svg";
import calender_icon from "../assets/icons/calender.svg";
// import favourites_icon from "../assets/icons/favourites.svg";
import draft_icon from "../assets/icons/draft.svg";
import premium_icon from "../assets/icons/premium_plan.svg";
import help_icon from "../assets/icons/help.svg";
import settings_icon from "../assets/icons/settings.svg";
// import profile_icon from "../assets/icons/account_circle.svg";
// import logout_icon from "../assets/icons/logout.svg";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import TobreLogo from "../assets/pic/tobreLogo.svg";
// import { FaUserCircle } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import { IoIosNotificationsOutline } from "react-icons/io";
import { PiUserCircleDuotone } from "react-icons/pi";
import { AiOutlineLogout, AiOutlineShoppingCart } from "react-icons/ai";
import { PiAddressBookBold } from "react-icons/pi";
import logo_black from "../assets/icons/logo_black.svg";
import { CustomerContext } from "../context/CustomerContext";
import { CartContext } from "../context/CartContext";
import CartSidebar from "./CartSidebar";
import { toast } from "react-toastify";
import { CardsContext } from "../context/CardsContext";
import { OpenCartContext } from "../context/OpenCartContext";

const DashboardNav = () => {
  const { customer, loader } = useContext(CustomerContext);
  const { cart, fetchCart } = useContext(CartContext);
  const { fetchCards } = useContext(CardsContext);
  const {isCartOpen, setCartOpen} = useContext(OpenCartContext);

  const [toggleMenu, setToggleMenu] = useState(false);
  const [profileMenu, setProfileMenu] = useState(false);
  const [notificationsMenu, setNotificationsMenu] = useState(false);
  const { pathname } = useLocation();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const notificationsRef = useRef(null);
  // const [cartOpen, setCartOpen] = useState(false);

  const handleToggleMenu = () => {
    setToggleMenu((prev) => !prev);
  };

  const handleprofileMenu = () => {
    setProfileMenu((prev) => !prev);
  };

  const fetchCustomer = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      // setCustomerCards(data?.data);
    } catch (error) {
      toast.error("Failed to fetch cards.");
    }
  };

  const handleDeleteItem = async (id) => {
    console.log("Deleting item with id:", id);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/cart/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": localStorage.getItem("token"),
          },
        }
      );

      const data = await res.json();
      console.log("Delete Response:", data);

      if (data.code === 200) {
        toast.success("Item removed from cart");
        if (window.gtag) {
          window.gtag('event', 'remove_from_cart', {
            currency: "USD", 
            value: data?.data?.amount || 0, 
            items: [
              {
                item_id: data?.data?.productId || id, 
                item_name: data?.data?.productName || "Cart Item",
                quantity: 1
              }
            ]
          });
        }
        fetchCart();
        fetchCards();
        fetchCustomer();
      } else {
        toast.error(data.message || "Delete failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.log("Delete API error:", err);
    }
  };

  const handleToggleNotificationsMenu = () => {
    if (!notificationsMenu) {
      // If the menu is about to open
      // markNotificationsAsSeen(); // Mark notifications as seen
    }
    setNotificationsMenu((prev) => !prev);
  };

  // const handleNotificationClick = (notification) => {
  //   console.log("Notification clicked:", notification._id);
  //   // markNotificationsAsSeen(notification._id)
  //   // Depending on your application, you might want to:
  //   // 1. Navigate to a specific route
  //   // 2. Mark the notification as read
  //   // 3. Open a detailed view of the notification
  // };

  const handleNotificationClick = (notification) => {
    // Extracting the recipient's name from the notification text
    // Assuming the format is always "<Name> has <event> round the corner..."
    const recipientName = notification.notification.split(" has")[0];

    // Extracting the event name from the notification type and removing " Reminder"
    const eventName = notification.type.replace(" Reminder", "");

    // Construct the event info string
    const eventInfo = encodeURIComponent(`${recipientName}'s ${eventName}`);

    // Mark the notification as seen
    markNotificationsAsSeen(notification._id);

    // Redirect to the event details page with the constructed title
    window.location.href = `/dashboard/event_details?title=${eventInfo}`;
  };

  const markNotificationsAsSeen = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/customer/seen-notifications/` + id,
        {
          method: "PUT", // Use the PUT method
          headers: {
            "x-sh-auth": localStorage.getItem("token"), // Include the auth token from localStorage
            "Content-Type": "application/json", // Set the Content-Type as JSON
          },
        }
      );

      const jsonResponse = await response.json();

      if (response.ok) {
        console.log("Notifications marked as seen:", jsonResponse);
        // Optionally, refresh notifications or update state here
      } else {
        // Handle non-200 responses
        console.error("Error marking notifications as seen:", jsonResponse);
      }
    } catch (error) {
      console.error("Failed to mark notifications as seen:", error);
    }
  };

  const Links = [
    {
      name: "My Cards",
      icon: logo_black,
      path: "/dashboard/print",
    },
    {
      name: "Card Generation",
      icon: card_generation_icon,
      path: "/dashboard/card_generation",
    },
    {
      name: "Address Book",
      icon: <PiAddressBookBold size={24} className="mr-3" />,
      path: "/dashboard/address_book",
    },
    // {
    //   name: "Address Book",
    //   icon: address_icon,
    //   path: "/dashboard/address_book",
    // },
    { name: "Calendar", icon: calender_icon, path: "/dashboard/calender" },
    // { name: "Favorites", icon: favourites_icon, path: "/dashboard/favorite" },
    { name: "Drafts & Favorites", icon: draft_icon, path: "/dashboard/draft" },
    {
      name: "Subscription Plans",
      icon: premium_icon,
      path: "/dashboard/premium_plan",
    },
    // { name: "Help", icon: help_icon, path: "/dashboard/help" },
    // { name: "Settings", icon: settings_icon, path: "/dashboard/settings" },
  ];

  // useEffect(() => {
  //   // Prevent scrolling of body content when the modal is open
  //   if (toggleMenu || profileMenu) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  // }, [toggleMenu, profileMenu]);

  useEffect(() => {
    // Extend the existing useEffect to also manage overflow for notifications menu
    if (toggleMenu || profileMenu || notificationsMenu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [toggleMenu, profileMenu, notificationsMenu]);

  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/get-notifications`,
          {
            method: "GET", // GET is the default method, so this line is optional
            headers: {
              "x-sh-auth": localStorage.getItem("token"),
            },
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const jsonResponse = await response.json();
        if (Array.isArray(jsonResponse.data)) {
          setNotifications(jsonResponse.data);
        } else {
          console.error(
            "Expected an array for notifications, received:",
            typeof jsonResponse.data
          );
          // Handle unexpected structure
          setNotifications([]);
        }
      } catch (error) {
        console.error("Fetching notifications failed:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []); // Dependency array left empty to run only once on mount

  useEffect(() => {
    // Improved handleClickOutside function
    const handleClickOutside = (event) => {
      if (
        notificationsMenu &&
        notificationsRef.current &&
        !notificationsRef.current.contains(event.target) &&
        !event.target.matches(".notification-toggle")
      ) {
        setNotificationsMenu(false);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Return a cleanup function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationsMenu]);

  return (
    <div>
      <nav className="fixed top-0 w-full flex items-center justify-between sm:px-4 px-3 border-b-2 border-slate-300 bg-white z-50">
        {profileMenu && (
          <div className="fixed right-5 top-16 lg:w-[15%] w-fit rounded-lg bg-white z-50">
            <Link to="/dashboard/profile">
              <button
                className="flex items-center justify-between hover:bg-primary-light text-xl py-3 lg:px-8 px-5 rounded-md focus:bg-primary-light w-full"
                onClick={handleprofileMenu}
              >
                Profile
                <span>
                  <PiUserCircleDuotone size={30} />
                </span>
              </button>
            </Link>
            <button
              className="flex items-center justify-between hover:bg-primary-light text-xl py-3 lg:px-8 px-5 rounded-md focus:bg-primary-light w-full"
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("ID");
                window.location.href = "/";
              }}
            >
              Log out
              <span>
                <AiOutlineLogout size={25} />
              </span>
            </button>
          </div>
        )}
        {toggleMenu && (
          <div className="fixed left-0 top-0 overflow-y-auto h-screen lg:w-[30%] w-[70%] bg-white z-50 xl:hidden animate-slide-in px-2 py-10">
            <img
              src={TobreLogo}
              alt="Logo"
              className="mx-auto mb-10 md:w-36 w-32"
            />
            <div className="flex flex-col items-center justify-center space-y-2 mt-7">
              {Links.map((link, index) => (
                <Link
                  to={link.path}
                  key={index}
                  className="flex items-center w-full"
                  onClick={handleToggleMenu}
                >
                  <button
                    className={`flex items-center py-2 lg:px-10 px-5 border-2 border-white rounded-md
                    ${
                      pathname === link.path
                        ? "bg-primary-light border-primary"
                        : "border-transparent"
                    }
                    hover:border-primary w-full`}
                  >
                    <span>
                      {link.name === "Address Book" ? (
                        link.icon
                      ) : (
                        <img
                          src={link.icon}
                          alt={link.name}
                          width={25}
                          className="mr-3"
                        />
                      )}
                    </span>
                    {link.name}
                  </button>
                </Link>
              ))}
              <button
                onClick={() => {
                  localStorage.removeItem("token");
                  localStorage.removeItem("ID");
                  window.location.href = "/";
                }}
                className={`flex items-center py-2 lg:px-10 px-5 rounded-md w-full hover:text-red-800 border-2 border-white hover:border-red-800 hover:bg-red-50 duration-200 ease-linear`}
              >
                <span>
                  <RiLogoutBoxLine className="mr-3" size={30} />
                </span>
                Logout
              </button>
            </div>
          </div>
        )}
        <CiMenuBurger
          className="xl:hidden"
          size={30}
          onClick={handleToggleMenu}
        />
        <Link to="/">
          <img src={TobreLogo} alt="Logo" className="md:w-40 w-28" />
        </Link>
        <div className="flex items-center">
          {/* <IoIosNotificationsOutline size={40} className="cursor-pointer"/> */}

          {!loader && !customer?.isSubscribed && (
            <div
              className="relative cursor-pointer"
              onClick={() => setCartOpen(true)}
            >
              <AiOutlineShoppingCart size={40} />
              <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs rounded-full px-1.5 py-0.5">
                {cart.items.length}
              </span>
            </div>
          )}

          <IoIosNotificationsOutline
            size={40}
            className="cursor-pointer notification-toggle"
            onClick={handleToggleNotificationsMenu} // Ensure this is correctly placed
          />

          <PiUserCircleDuotone
            className="cursor-pointer ml-2"
            size={60}
            onClick={handleprofileMenu}
          />
        </div>

        {notificationsMenu && (
          <div
            ref={notificationsRef}
            className="fixed right-5 top-16 lg:w-[20%] w-64 rounded-lg bg-white z-50 shadow-lg overflow-hidden"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            <div className="p-4">
              <h3 className="font-semibold text-lg">Notifications</h3>
              {loading ? (
                <div>Loading...</div>
              ) : error ? (
                <div>Error: {error}</div>
              ) : (
                <ul className="mt-2">
                  {notifications.map((notification) => (
                    <li
                      key={notification._id}
                      className={`notification-item ${
                        !notification.isSeen ? "unseen" : ""
                      }`}
                      onClick={() => handleNotificationClick(notification)}
                    >
                      <div className="notification-content">
                        <p className="text-sm font-medium text-gray-900">
                          {notification.notification}
                        </p>
                        <p className="notification-date">
                          {new Date(
                            notification.createdAt
                          ).toLocaleDateString()}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}

        {/* Hidden Sidebar Overlay */}
        {toggleMenu && (
          <div
            className="fixed left-0 top-0 h-screen w-screen bg-black opacity-30 z-40 xl:hidden"
            onClick={handleToggleMenu}
          />
        )}

        {profileMenu && (
          <div
            className="fixed left-0 top-0 h-screen w-screen bg-black opacity-30 z-40"
            onClick={handleprofileMenu}
          />
        )}
      </nav>
      <CartSidebar
        open={isCartOpen}
        onClose={() => setCartOpen(false)}
        cart={cart}
        onDelete={handleDeleteItem}
        onOrderSuccess={fetchCart}
      />
    </div>
  );
};

export default DashboardNav;
